import { T, base } from "../lib/theme";

const Btn = ({ children, variant = "primary", size = "md", onClick, disabled, style: extraStyle = {} }) => {
  const variants = {
    primary:   { background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "#fff", border: "none" },
    danger:    { background: T.rose,    color: "#fff",   border: "none" },
    ghost:     { background: T.bg2,     color: T.text2,  border: `1px solid ${T.border1}` },
    secondary: { background: T.bg2,     color: T.text2,  border: `1px solid ${T.border2}` },
    outline:   { background: "transparent", color: T.text2, border: `1px solid ${T.border2}` },
    sky:       { background: T.skyDim,  color: T.sky,    border: `1px solid rgba(56,189,248,0.2)` },
  };
  const sizes = {
    sm: { padding: "5px 13px",  fontSize: 12, borderRadius: 8  },
    md: { padding: "8px 18px",  fontSize: 13, borderRadius: 9  },
    lg: { padding: "11px 24px", fontSize: 14, borderRadius: 10 },
  };
  const v = variants[variant] || variants.primary;
  const sz = sizes[size] || sizes.md;
  return (
    <button
      className={`btn-${variant}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "inline-flex", alignItems: "center", gap: 7,
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: base.font, fontWeight: 500,
        transition: "all 0.15s", opacity: disabled ? 0.48 : 1,
        whiteSpace: "nowrap",
        ...v, ...sz, ...extraStyle,
      }}
    >
      {children}
    </button>
  );
};

export default Btn;
